// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3df04166203a72b2","8716":"3c3ca2764a97569e"}[chunkId] + ".css";
};